define('lq/events/actions/formula',[
    'lq/events/actions/eventAction',
    'jquery',
    'underscore',
    'globalize',
    'lq/constants'
], function (EventAction, $, _, globalize, constants) {
    'use strict';

    function Formula(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.formula = this.eventData.formula;
        return this;
    }

    EventAction.extend(Formula, EventAction);

    Formula.typeName = 'Formula';

    Formula.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };
    
    var fillInTheValuesFromMorphsWithAViewModelKey = function (dropFactory, targetObj) {
        var drops = dropFactory.getAllDrops();
        var morphsWithViewModelKey = _.filter(drops, function (morph) {
            return morph.data.viewModelKey && morph.getValue;
        });
        $.each(morphsWithViewModelKey, function (index, morph) {
            targetObj[morph.data.viewModelKey] = morph.getValue();
        });
    };

    var isValidName = function (parameterName) {
        return parameterName.match(/^[$A-Za-z_][0-9A-Za-z_$]*$/g);
    };

    var createSeparateListsWithNamesAndValues = function (argumentsWithTheirValue) {
        var args = [];
        var values = [];
        for (var argument in argumentsWithTheirValue) {
            if (isValidName(argument)) {
                var value = argumentsWithTheirValue[argument];
                args.push(argument);
                values.push(value);
            }
        }

        return {
            args: args,
            values: values
        };
    };

    var buildListOfArguments = function (dropFactory, argumentsWithTheirValue) {
        fillInTheValuesFromMorphsWithAViewModelKey(dropFactory, argumentsWithTheirValue);
        return createSeparateListsWithNamesAndValues(argumentsWithTheirValue);
    };

    var getBodyOfFunction = function (formula) {
        var body = formula.expression;
        if (body.indexOf('\n') == -1 && !body.indexOf('return') == 0) {
            body = 'return ' + body + ';';
        }
        return body;
    };
    
    var getResultFromFunction = function (bodyOfFunction, argumentsWithTheirValues) {
        var theFunction = new Function(argumentsWithTheirValues.args, bodyOfFunction);
        var result = theFunction.apply(this, argumentsWithTheirValues.values);

        if (result != null && result.constructor === Date)
            result = globalize.format(result, constants.licquidDateFormat);

        return result;
    };

    Formula.prototype.execute = function (continuation, eventActionResponse) {
        var argumentsWithTheirValues = buildListOfArguments(this.piping.dropFactory, this.piping.parameters.getAll());
        var bodyOfFunction = getBodyOfFunction(this.formula);
        var result = getResultFromFunction(bodyOfFunction, argumentsWithTheirValues);

        var targetParameters = this.formula.targetParameterIsGlobal
            ? this.piping.parameters.globals
            : this.piping.parameters.locals;
        targetParameters.setValue(this.formula.targetParameter, result);
        
        continuation();
    };

    return Formula;
});
